var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#10B07C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8336 5.11612C15.3218 4.62796 16.1132 4.62796 16.6014 5.11612C17.0896 5.60427 17.0896 6.39573 16.6014 6.88388L8.88388 14.6014C8.39573 15.0896 7.60427 15.0896 7.11612 14.6014L3.11612 10.6014C2.62796 10.1132 2.62796 9.32179 3.11612 8.83363C3.60427 8.34548 4.39573 8.34548 4.88388 8.83363L8 11.9498L14.8336 5.11612Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.72d797b1.svg";
export { ForwardRef as ReactComponent };